declare namespace $ {

	export class $mol_icon_arrow_collapse extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=collapse.view.tree.d.ts.map